import { render } from "./App.vue?vue&type=template&id=07c509fe&bindings={\"twitterUrl\":\"data\",\"facebookUrl\":\"data\",\"instagramUrl\":\"data\",\"pinterestUrl\":\"data\",\"googlePlayUrl\":\"data\",\"appStoreUrl\":\"data\",\"features\":\"data\",\"email\":\"data\",\"contactEmail\":\"data\",\"newsletterSuccess\":\"data\",\"emailLink\":\"options\",\"onSubmit\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script